/// <reference path="../vite-env.d.ts" />

export function showIntercom() {
  window.Intercom?.('show');
}
